import { Eye, Bookmark } from 'lucide-react';

/**
 * SocialProof
 * -----------
 * Tiny stats row for story cards. Shows view + save counts when present so
 * readers see "1.2K reads · 47 saves" — credibility without clutter.
 *
 * Renders nothing if both counts are 0/missing.
 */
const fmt = (n) => {
  if (!Number.isFinite(n)) return null;
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(n >= 10_000 ? 0 : 1)}K`;
  return `${n}`;
};

const SocialProof = ({ story, className = '', theme = 'light' }) => {
  const views = story?.view_count || 0;
  const saves = story?.save_count || 0;
  if (views === 0 && saves === 0) return null;
  const txt = theme === 'dark' ? 'text-white/70' : 'text-gray-500';
  return (
    <div className={`flex items-center gap-3 text-[11px] font-bold uppercase tracking-widest ${txt} ${className}`}>
      {views > 0 && (
        <span className="inline-flex items-center gap-1" data-testid="social-proof-views">
          <Eye className="w-3 h-3" /> {fmt(views)}
        </span>
      )}
      {saves > 0 && (
        <span className="inline-flex items-center gap-1" data-testid="social-proof-saves">
          <Bookmark className="w-3 h-3" /> {fmt(saves)}
        </span>
      )}
    </div>
  );
};

export default SocialProof;
